export const fmtClock = (iso) => new Date(iso).toLocaleTimeString("id-ID", { timeZone: "Asia/Jakarta", hour: "2-digit", minute: "2-digit" });

export const fmtDate = (d) => new Date(`${d}T00:00:00+07:00`).toLocaleDateString("id-ID", { timeZone: "Asia/Jakarta", weekday: "short", day: "2-digit", month: "short" });

export const fmtDuration = (m) => `${Math.floor(m / 60)}j ${m % 60}m`;

export const shiftLabel = (config, id) => {
  const s = config.shifts.find((x) => x.id === id);
  return s ? `Shift ${s.label}` : "-";
};

export const todayWIB = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Jakarta" });

export const addDays = (d, n) => {
  const x = new Date(`${d}T12:00:00Z`);
  x.setUTCDate(x.getUTCDate() + n);
  return x.toISOString().slice(0, 10);
};

export const SHIFT_STYLE = {
  pagi: "bg-amber-50 text-amber-800 border-amber-200",
  sore: "bg-sage-100 text-forest border-sage-200",
  malam: "bg-ink text-paper border-ink",
  libur: "bg-red-50 text-red-700 border-red-200",
  "": "bg-paper text-muted2 border-sage-200",
};

export const shiftName = (config, id) => (id === "libur" ? "Libur" : config.shifts.find((s) => s.id === id)?.label || "–");

export const STATUS_STYLE = {
  menunggu: "bg-amber-50 text-amber-800",
  disetujui: "bg-emerald-50 text-emerald-700",
  ditolak: "bg-red-50 text-red-700",
};

export const StatusPill = ({ rec }) => {
  const late = rec.status === "terlambat";
  return (
    <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full border ${late ? "bg-amber-100 text-amber-800 border-amber-200" : "bg-sage-100 text-forest border-sage-200"}`}>
      {late ? `Terlambat ${rec.late_minutes} mnt` : "Tepat waktu"}
    </span>
  );
};
